import { render, staticRenderFns } from "./error403.vue?vue&type=template&id=54ed0298"
import script from "./error403.vue?vue&type=script&lang=js"
export * from "./error403.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports